var map = {
	"./about-1.svg": "./assets/svg/about-1.svg",
	"./about-2.svg": "./assets/svg/about-2.svg",
	"./areas-1.svg": "./assets/svg/areas-1.svg",
	"./areas-2.svg": "./assets/svg/areas-2.svg",
	"./areas-3.svg": "./assets/svg/areas-3.svg",
	"./areas-4.svg": "./assets/svg/areas-4.svg",
	"./areas-5.svg": "./assets/svg/areas-5.svg",
	"./areas-6.svg": "./assets/svg/areas-6.svg",
	"./burger.svg": "./assets/svg/burger.svg",
	"./ohm-logo.svg": "./assets/svg/ohm-logo.svg",
	"./soc-fb.svg": "./assets/svg/soc-fb.svg",
	"./soc-tw.svg": "./assets/svg/soc-tw.svg",
	"./team.svg": "./assets/svg/team.svg",
	"./wedo-1.svg": "./assets/svg/wedo-1.svg",
	"./wedo-2.svg": "./assets/svg/wedo-2.svg",
	"./wedo-3.svg": "./assets/svg/wedo-3.svg",
	"./wedo-4.svg": "./assets/svg/wedo-4.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./assets/svg sync recursive ([\\w-]+)\\.svg$";